<template>
  <!-- 轮播图片 -->
  <div class="carousel">
    <el-carousel
      indicator-position="none"
      :height="height + 'px'"
      :type="card"
      :loop="true"
      :interval="interval"
      trigger="click"
      arrow="always"
      @change="carouselChange"
      ref="carousel"
    >
      <!-- VIP -->
      <el-carousel-item
        :width="'100px'"
        class="border1"
        :class="{
          css_left: carouseId == 1,
          css_left: carouseId == 1,
          css_right: carouseId == 2,
        }"
      >
        <div v-if="carouseId == 0">
          <div class="box-header1 box-header">
            <a class="buy-explaen">购买说明</a>
            <h1 class="header-title" style="color: white">
              {{ centre.levelName }}
            </h1>
            <p style="color: white; font-size: 26px; margin-top: 10px">
              商务人士超值之选
            </p>
            <p style="margin-top: 20px; color: #fff">超值权益</p>
          </div>
          <div>
            <div class="box-center">
              <div
                class="center-item"
                :class="isActive == index && 'is_active'"
                @click="handCenterItem(item, index)"
                v-for="(item, index) in centre.compBuyMemberResList"
                :key="index"
              >
                <div class="c-gray">{{ item.name }}</div>
                <div>
                  <span class="c-blue">￥</span>
                  <span class="m-number" style="color: #2691fd">{{
                    item.amount
                  }}</span>
                  <!-- <span class="c-gray">年</span> -->
                </div>
                <div class="c-gray line-through">￥{{ item.oldAmount }}</div>
                <el-image
                  class="tuijian"
                  v-if="index == 0"
                  style="width: 54px; height: 24px"
                  src="https://oss.yanxin7.cn/2023-08-16/26e675b95da7bd54c4539ba464386fdd"
                ></el-image>
              </div>
            </div>
            <el-button
              class="vip-btn"
              @click="handOPenNow(centre.compBuyMemberResList)"
              >立即开通</el-button
            >
            <p class="pay-hint">支付后可开发票</p>
          </div>
        </div>
        <div v-else>
          <div
            class="box-header-sub"
            style="
              background: url('https://oss.yanxin7.cn/2023-08-17/0d24c50bfae03de972261645ff9dd4e8');
              background-size: 100% 100%;
            "
          >
            <h1 class="header-title">{{ centre.levelName }}</h1>
            <p class="sub-title">商务人士超值之选</p>
          </div>
          <div class="lr-item">
            <div>
              <div>
                <span class="c-blue">￥</span
                ><span class="sub-number" v-if="centre.compBuyMemberResList">{{
                  centre.compBuyMemberResList[0].amount
                }}</span>
                <!-- <span class="c-gray">/年</span> -->
              </div>
              <el-button class="vip-btns">立即开通</el-button>
            </div>
            <p></p>
          </div>
        </div>
      </el-carousel-item>
      <!-- SVIP -->
      <el-carousel-item
        :width="'100px'"
        class="border1"
        :class="{
          css_right: carouseId == 0,
          css_left: carouseId == 2,
        }"
      >
        <div v-if="carouseId == 1">
          <div class="box-header2 box-header">
            <a class="buy-explaen">购买说明</a>
            <h1 class="header-title">{{ rigth.levelName }}</h1>
            <p style="font-size: 26px; color: #ffdcc1; margin-top: 10px">
              商务人士理想之选
            </p>
          </div>
          <div>
            <div class="box-center">
              <div
                class="center-item"
                :class="isActive == index && 'is_active'"
                @click="handCenterItem(item, index)"
                v-for="(item, index) in rigth.compBuyMemberResList"
                :key="index"
              >
                <div class="c-gray">{{ item.name }}</div>
                <div>
                  <span class="c-blue" style="color: #914003">￥</span>
                  <span class="m-number" style="color: #713100">{{
                    item.amount
                  }}</span>
                  <!-- <span class="c-gray">年</span> -->
                </div>
                <div class="c-gray line-through">￥{{ item.oldAmount }}</div>
                <el-image
                  class="tuijian"
                  v-if="index == 0"
                  style="width: 54px; height: 24px"
                  src="https://oss.yanxin7.cn/2023-08-16/26e675b95da7bd54c4539ba464386fdd"
                ></el-image>
              </div>
            </div>
            <el-button
              class="svip-btn"
              @click="handOPenNow(rigth.compBuyMemberResList)"
              >立即开通</el-button
            >
            <p class="pay-hint">支付后可开发票</p>
          </div>
        </div>
        <div v-else>
          <div
            class="box-header-sub"
            style="
              background: url('https://oss.yanxin7.cn/2023-08-17/6aa9afd9c760f248f620edd717d85314');
              background-size: 100% 100%;
            "
          >
            <h1 class="header-title">{{ rigth.levelName }}</h1>
            <p class="sub-title">商务人士理想之选</p>
          </div>
          <div class="lr-item">
            <div>
              <div>
                <span class="c-blue">￥</span
                ><span class="sub-number" v-if="rigth.compBuyMemberResList">{{
                  rigth.compBuyMemberResList[0].amount
                }}</span>
                <!-- <span class="c-gray">/年</span> -->
              </div>
              <el-button class="svip-btns">立即开通</el-button>
            </div>
            <p></p>
          </div>
        </div>
      </el-carousel-item>
      <!-- BVIP -->
      <el-carousel-item
        class="border1"
        :width="'100px'"
        :class="{
          css_left: carouseId == 0,
          css_right: carouseId == 1,
        }"
      >
        <div v-if="carouseId == 2">
          <div class="box-header3 box-header">
            <a class="buy-explaen">购买说明</a>
            <h1 class="header-title" style="color: #713100">
              {{ left.levelName }}
            </h1>
            <p style="font-size: 26px; margin-top: 10px; color: #713100">
              商务人士经典之选
            </p>
          </div>
          <div>
            <div class="box-center">
              <div
                class="center-item"
                :class="isActive == index && 'is_active'"
                @click="handCenterItem(item, index)"
                v-for="(item, index) in left.compBuyMemberResList"
                :key="index"
              >
                <div class="c-gray">{{ item.name }}</div>
                <div>
                  <span class="c-blue" style="color: #8f4004">￥</span>
                  <span class="m-number" style="color: #713100">{{
                    item.amount
                  }}</span>
                  <div class="c-gray line-through">￥{{ item.oldAmount }}</div>
                </div>
                <el-image
                  class="tuijian"
                  v-if="index == 0"
                  style="width: 54px; height: 24px"
                  src="https://oss.yanxin7.cn/2023-08-16/26e675b95da7bd54c4539ba464386fdd"
                ></el-image>
              </div>
            </div>
            <el-button
              class="put-btn"
              @click="handOPenNow(left.compBuyMemberResList)"
              >立即开通</el-button
            >
            <p class="pay-hint">支付后可开发票</p>
          </div>
        </div>
        <div v-else>
          <div
            class="box-header-sub"
            style="
              background: url('https://oss.yanxin7.cn/2023-08-17/6499ce084eddd739eda8c62c6aef6f32');
              background-size: 100% 100% !important;
              background-repeat: no-repeat;
            "
          >
            <h1
              class="header-title"
              style="color: #713100; font-size: 36px; margin-bottom: 4px"
            >
              普通会员
            </h1>
            <p class="sub-title" style="color: #713100; font-size: 18px">
              商务人士经典之选
            </p>
          </div>
          <div class="lr-item">
            <div>
              <div>
                <span class="c-blue" style="color: #713100">￥</span
                ><span
                  class="sub-number"
                  style="color: #713100"
                  v-if="left.compBuyMemberResList"
                  >{{ left.compBuyMemberResList[0].amount }}</span
                >
                <!-- <span class="c-gray">/年</span> -->
              </div>
              <el-button class="putong-btn">立即开通</el-button>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { memberInfoList } from "@/api/member";
export default {
  name: "Carousel",
  //接收来自父组件的数据
  props: {
    // 轮播图宽度
    width: {
      type: Number,
      default: 100,
    },
    card: {
      type: String,
      default: "card",
    },
    height: {
      type: String,
      default: "500",
    },
    // 相邻两张图片切换的间隔时间
    interval: {
      type: Number,
      default: 1112000,
    },
    //图片宽
    widthImage: {
      type: Number,
      default: 100,
    },
    //图片高
    heightImage: {
      type: Number,
      default: 50,
    },
    // 轮播图路径数组
    carouselList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  computed: {
    ...mapState("account", ["userInfos"]),
  },
  data() {
    return {
      isActive: 0,
      carouseId: 0,
      left: {},
      centre: {},
      rigth: {},
      allData: [],
      curentData: {},
    };
  },

  mounted() {
    this.getMemberInfoList();
  },
  methods: {
    handOPenNow(e) {
      if (this.curentData.id) {
        this.$emit("handPersonMember", this.curentData, e, this.isActive);
        console.log("this.curentData", this.curentData, this.isActive);
      } else {
        this.$emit("handPersonMember", e[0], e, this.isActive);
      }
    },
    getCurentRouterParams() {
      this.mmemberType = this.$route.query.type;
    },
    async getMemberInfoList() {
      try {
        const { data } = await memberInfoList({});
        if (data.persionMemberList.length > 0) {
          this.left = data.persionMemberList[0]
            ? data.persionMemberList[0]
            : [];
          this.centre = data.persionMemberList[1]
            ? data.persionMemberList[1]
            : [];
          this.rigth = data.persionMemberList[2]
            ? data.persionMemberList[2]
            : [];
        }
      } catch (error) {
        console.log("getMemberInfoListErr", error);
      }
    },
    carouselChange(now, old) {
      this.carouseId = now;
      this.curentData = {};
      this.isActive = 0;
    },
    post() {
      // 接口数据
      let postList = this.list;
      this.left = postList[0];
      this.centre = postList[1];
      this.rigth = postList[2];
    },
    handCenterItem(item, index) {
      this.isActive = index;
      this.curentData = item;
    },
  },
};
</script>

<style scoped>
.carousel {
  padding-bottom: 40px;
}
.box-header {
  position: relative;
}
.buy-explaen {
  position: absolute;
  right: 20px;
  color: white;
}
.css_left {
  width: 400px;
  margin-left: 35px;
  margin-top: 65px;
  height: 300px !important;
  border: 1px solid rgb(245, 242, 242);
  border-radius: 10px;
}
.line-through {
  text-decoration: line-through;
}
.css_right {
  width: 400px;
  margin-left: 265px;
  margin-top: 65px;
  height: 300px !important;
  border: 1px solid rgb(245, 242, 242);
  border-radius: 10px;
}

.el-carousel {
  overflow-x: hidden;
  overflow-y: hidden;
  width: 1400px;
}

.el-carousel__item {
  background-color: #fff;
}

.image {
  height: 550px;
}

::v-deep .el-carousel__arrow--left {
  display: none;
}
::v-deep .el-carousel__arrow--right {
  display: none;
}
::v-deep .is-active {
  border: 1px solid rgb(243, 240, 240);
  border-radius: 10px;
}
.box-header-sub {
  height: 140px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: 19px;
  margin-bottom: 49px;
}
.header-title {
  font-size: 40px;
  color: #ffdcc1;
  font-weight: bolder;
  position: relative;
}
.sub-title {
  font-size: 18px !important;
  color: #ffdcc1;
}
.box-center {
  display: flex;
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 60px;
}
.center-item {
 
  padding-top: 18px !important;
  flex-direction: column;
  display: flex;
  width: 160px;
  height: 96px;
  border: 1px solid rgb(219, 216, 216);
  position: relative;
}
.m-number {
  font-weight: bold;
  margin: 0 5px;
  font-size: 22px;
}
.c-gray {
  color: rgb(168, 166, 166);
  font-size: 14px;
}
.c-blue {
  color: #2288fc;
  font-size: 14px;
}
.tuijian {
  position: absolute;
  top: -5px;
  left: -2px;
}
.is_active {
  background: url(https://oss.yanxin7.cn/2023-08-16/779a2f9117f301a0716ab8e2fe6cefa6);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.pay-hint {
  color: rgb(177, 175, 175);
  margin-top: 10px;
}
.lr-item {
  margin-top: -20px;
}
.sub-number {
  font-weight: bolder;
  color: #2288fc;
  font-size: 26px;
  margin: 0 5px;
}
.put-btn {
  font-size: 20px;
  color: #fff;
  width: 300px;
  height: 50px;
  color: #713100 !important;
  background: linear-gradient(to right, #ffefdc, #f5cd9f);
}
.vip-btn {
  font-size: 20px;
  color: #fff;
  width: 300px;
  height: 50px;
  background: linear-gradient(to right, #2ea3ff, #2288fc);
}
.svip-btn {
  font-size: 20px;
  color: #fff;
  width: 300px;
  height: 50px;
  background: linear-gradient(to right, #ffd182, #f5a245);
}
.box-header1 {
  margin-bottom: 49px;
  padding-top: 19px;
  height: 180px;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  background: url("https://oss.yanxin7.cn/2023-08-17/0d24c50bfae03de972261645ff9dd4e8");
}
.box-header2 {
  margin-bottom: 49px;
  padding-top: 19px;
  height: 180px;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  background: url("https://oss.yanxin7.cn/2023-08-17/6aa9afd9c760f248f620edd717d85314");
}
.box-header3 {
  color: #713100;
  margin-bottom: 49px;
  padding-top: 19px;
  height: 180px;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  background: url("https://oss.yanxin7.cn/2023-08-17/6499ce084eddd739eda8c62c6aef6f32");
}
.putong-btn {
  color: #713100 !important;
  background: linear-gradient(to right, #ffefdc, #f5cd9f);
  font-weight: bolder;
  margin-top: 20px;
  font-size: 20px;
  color: #fff;
  width: 142px;
  height: 50px;
}
.vip-btns {
  margin-top: 20px;

  font-size: 20px;
  color: #fff;
  width: 142px;
  height: 50px;
  background: linear-gradient(to right, #2ea3ff, #2288fc);
}
.svip-btns {
  margin-top: 20px;
  font-size: 20px;
  color: #fff;
  width: 142px;
  height: 50px;
  background: linear-gradient(to right, #ffd182, #f5a245);
}
.border1 {
  border: 1px solid rgb(219, 216, 216);
  border-radius: 15px;
}
</style>